import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgTeamworkOndersteunen = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 40 40"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <path
      fill="#60D15D"
      d="M15.17 20a6 6 0 1 0 0-12 6 6 0 0 0 0 12"
    />
    <path
      fill="#00215B"
      fillRule="evenodd"
      d="M13.217 14.427a3.02 3.02 0 0 0 6.006 0l.994.106a4.02 4.02 0 0 1-7.994 0z"
      clipRule="evenodd"
    />
    <path
      fill="#60D15D"
      fillRule="evenodd"
      d="M15.2 20a6 6 0 0 1 6 6v8h-12v-8a6 6 0 0 1 6-6"
      clipRule="evenodd"
    />
    <path
      fill="#B3E9B1"
      d="M24.8 18a6 6 0 1 0 0-12 6 6 0 0 0 0 12"
    />
    <path
      fill="#B3E9B1"
      fillRule="evenodd"
      d="M24.8 18a6 6 0 0 1 6 6v10h-12V24a6 6 0 0 1 6-6"
      clipRule="evenodd"
    />
    <path
      fill="#60D15D"
      d="M28.8 22a2 2 0 1 0 0-4 2 2 0 0 0 0 4"
    />
    <path
      fill="#00215B"
      fillRule="evenodd"
      d="M21.817 12.417a3.02 3.02 0 0 0 6.006 0l.994.106a4.02 4.02 0 0 1-7.994 0z"
      clipRule="evenodd"
    />
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgTeamworkOndersteunen);

export default ForwardRef;
